import { observer } from 'mobx-react-lite';

import type { AlertsManagerWidgetState } from '../AlertsManagerWidgetState';
import type { ViewStore } from '../stores/ViewStore';

import { AlertRulesView } from './AlertRulesView';
import { AutoAnomalyView } from './AutoAnomalyView';
import { ManualAnomaliesView } from './ManualAnomaliesView';

type ViewResolverProps = {
  viewStore: ViewStore;
  widgetState: AlertsManagerWidgetState;
};

export const ViewResolver = observer(function ViewResolver({ viewStore, widgetState }: ViewResolverProps) {
  if (viewStore.current.name === 'alertRulesTime' || viewStore.current.name === 'alertRulesDepth') {
    return (
      <AlertRulesView
        viewStore={viewStore}
        service={viewStore.current.view.service}
        notifications={widgetState.notifications}
        widgetState={widgetState}
      />
    );
  }

  if (viewStore.current.name === 'autoAnomalies') {
    return <AutoAnomalyView viewStore={viewStore} controller={viewStore.current.view} widgetState={widgetState} />;
  }

  if (viewStore.current.name === 'manualAnomalies') {
    return <ManualAnomaliesView viewStore={viewStore} controller={viewStore.current.view} widgetState={widgetState} />;
  }

  return null;
});
